import { Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { CustomerActions } from './customer-actions';
import { DispatcherModule } from '../dispatcher.module';
import { AppState } from '../state.model';


@Injectable({
  providedIn: DispatcherModule,
})
export class CustomerDispatcher {

  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }

  /**
  * customerFound Indicates if the  customer is found (ignoring all the other errors)
  * @param flag true if customer found
  **/
  customerFound(flag: boolean): void {
    this.ngRedux.dispatch(CustomerActions.customerFound(flag));
  }
  /**
  * customerNotFoundError Indicates if the response error is customer not found or not
  * @param flag true if error is customer not found
  **/
  customerNotFoundError(flag: boolean): void {
    this.ngRedux.dispatch(CustomerActions.customerNotFoundError(flag));
  }
  /**
  * setErrorCode sets the error code in redux
  * @param code error code from the api
  **/
  setErrorCode(code: string): void {
    this.ngRedux.dispatch(CustomerActions.setErrorCode(code));
  }
  /**
  * setSearchValue sets the search value of customer
  * @param searchValue search value {emai: ''} or {phone:''}
  **/
  setSearchValue(searchValue: object): void {
    this.ngRedux.dispatch(CustomerActions.setSearchValue(searchValue));
  }
  /**
* setCustomerDetails sets customer details
* @param first_name first name of customer
* @param last_name last name of customer
* @param email email of customer
* @param phone phone of customer
**/
  setCustomerDetails(first_name: string, last_name: string, email: string, phone: string): void {
    this.ngRedux.dispatch(CustomerActions.setCustomerDetails(first_name, last_name, email, phone));
  }
  /**
  * setCustomerAddress set the address of the customer
  * @param address address of customer
  **/
  setCustomerAddress(address: object): void {
    this.ngRedux.dispatch(CustomerActions.setCustomerAddress(address));
  }
  /**
* setCustomerData set the data of the customer with updated details
* @param data updated details of customer
**/
  setCustomerData(data: object): void {
    this.ngRedux.dispatch(CustomerActions.setCustomerData(data));
  }
  /**
  * setPrefferedLanguage set prefered lang
  * @param preferredLanguage preferredLanguage of customer
  **/
  setPrefferedLanguage(preferredLanguage: string): void {
    this.ngRedux.dispatch(CustomerActions.setPrefferedLanguage(preferredLanguage));
  }
  /**
  * setPrefLangApiCall set prefered lang
  * @param isCalled is the api called
  **/
  setPrefLangApiCall(isCalled: boolean): void {
    this.ngRedux.dispatch(CustomerActions.setPrefLangApiCall(isCalled));
  }
  /**
  * setCreateDate set create date
  * @param createAccountTimestamp createAccountTimestamp of customer
  **/
  setCreateDate(createAccountTimestamp: string): void {
    this.ngRedux.dispatch(CustomerActions.setCreateDate(createAccountTimestamp));
  }
}
